export default "__VITE_ASSET__Dguszy23__"